import { render, staticRenderFns } from "./Fangzhuan.vue?vue&type=template&id=72599118&"
import script from "./Fangzhuan.vue?vue&type=script&lang=js&"
export * from "./Fangzhuan.vue?vue&type=script&lang=js&"
import style0 from "./Fangzhuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports